module.exports = function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
};



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_has.js
// module id = 33
// module chunks = 47